// @flow

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import OperatorsList from './OperatorsList';

export default class EstablishmentModal extends Component {


    render() {
        const { show, handleClose } = this.props;
        return (
            <Modal
                animation={false}
                show={show}
                onHide={handleClose}
                className="modal"
                dialogClassName="modal-lg modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-400 fs-14">Trocar Unidade</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <OperatorsList />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger btn-outline" onClick={handleClose}>Fechar</button>
                    <button type="button" className="btn btn-info btn-outline" onClick={() => {}}>Trocar</button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/EstablishmentModal/index.js